import {Subscription} from "rxjs";

export function clearSubscriptions(subscriptions: Subscription[]) {
  subscriptions?.forEach(subsc => {
    if (subsc && !subsc.closed) {
      subsc.unsubscribe();
    }
  });
}
